import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'
import Card from '../components/ui/Card'
import Button from '../components/ui/Button'

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Card className="max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-secondary-900 dark:text-white">404</h1>
        <p className="mt-2 text-secondary-600 dark:text-secondary-400">
          Trang bạn đang tìm không tồn tại.
        </p>
        <Button as={Link} to="/" className="mt-6" leftIcon={<Home className="w-4 h-4" />}>
          Về dashboard
        </Button>
      </Card>
    </div>
  )
}
